import { render, staticRenderFns } from "./kargoTesellum.vue?vue&type=template&id=49ebda34"
import script from "./kargoTesellum.vue?vue&type=script&lang=js"
export * from "./kargoTesellum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports